import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShuffle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { formatCurrency } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import Select from "react-select";

function Swap() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);    
  const [fiat, setFiat] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [fee, setFee] = useState(0.5);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchadmin: true })
    })
    .then(response =>  response.json())
    .then(data => {
      if (data.status === "success") {
        setFee(data.admin.swap_fee);
      }else{
      }
    })
    .catch(err => {
    })
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data.sort((a, b) => a.name.localeCompare(b.name));
      const updatedData = coinList.map((coin, index) => {
        const walletItem = wallet.find(item => item.coinName === coin.name);
        return {
          id: index + 1,
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          name: coin.name,
          price: Number(coin.quote.USD.price.toFixed(2)),
          value: coin.symbol,
          balance: walletItem ? walletItem.balance : 0,
        };
      });
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => {
            const walletItem = wallet.find(item => item.coinName === wantedCurrencies[code]);
            return {
              id: index + 1,
              value: code,
              name: wantedCurrencies[code],
              price: Number(value),
              label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {code}</>,
              balance: walletItem ? walletItem.balance : 0,
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {
    if (!crypto.length && !fiat.length) return;
    const merged = [
    ...crypto,
    ...fiat
    ];
    const sorted = merged.sort((a, b) => a.name.localeCompare(b.name));
    setAssethistory(sorted);
  }, [crypto, fiat]);
  const darkThemeStyles1 = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      border: "none",
      color: "#fff",
      fontWeight: '600',
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      fontWeight: '600',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
      color: "#fff",
      fontWeight: '600',
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
      fontWeight: '600',
    }),
  };
  //SWAP CODE
  const [error, setError] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [disable1, setDisable1] = useState(true);
  const [swapAmountOne, setSwapAmountOne] = useState(0);
  const [swapAmountTwo, setSwapAmountTwo] = useState(0);
  const [swapOne, setSwapOne] = useState(assethistory[10] ? assethistory[10].value : "BTC");
  const [swapTwo, setSwapTwo] = useState(assethistory[20] ? assethistory[20].value : "ETH");
  const [swapOneDetails, setSwapOneDetails] = useState([]);
  const [swapTwoDetails, setSwapTwoDetails] = useState([]);
  useEffect(() => {
    if(swapAmountOne && swapAmountTwo && !error){
        setDisable1(false);
    }else{
        setDisable1(true);
    }
  }, [swapAmountOne, swapAmountTwo, error]);
  useEffect(() => {
    const swapOneDetails = assethistory.find(opt => opt.value === swapOne);
    if (swapOneDetails) {
        setSwapOneDetails(swapOneDetails);
    } else {
        setSwapOneDetails([]);
    }
    const swapTwoDetails = assethistory.find(opt => opt.value === swapTwo);
    if (swapTwoDetails) {
        setSwapTwoDetails(swapTwoDetails);
    } else {
        setSwapTwoDetails([]);
    }
  }, [assethistory, swapOne, swapTwo]);
  function validateSwapOne({ value, swaponeprice, swaptwoprice, swaponebalance, twoSymbol }){
    var amount = (value ?? swapAmountOne);
    var swapOneUS = (amount * (swaponeprice ?? swapOneDetails.price) );
    var swapOneUSd = swapOneUS - (Number(swapOneUS) * (fee/100));
    var swayTwoSymbol = (twoSymbol ?? swapTwo);
    const wantedCurrencies = {
        AUD: 'Australian Dollar',
        CAD: 'Canadian Dollar',
        CHF: 'Swiss Franc',
        CNY: 'Chinese Yuan',
        EUR: 'Euro',
        GBP: 'British Pound',
        INR: 'Indian Rupee',
        JPY: 'Japanese Yen',
        RUB: 'Russian Ruble',
        USD: 'US Dollar',
        ZAR: 'South African Rand'
    };
    const isFiat = wantedCurrencies.hasOwnProperty(swayTwoSymbol);
    let swapTwoAmt;
    if (isFiat) {
      swapTwoAmt = swapOneUSd / (1 / (swaptwoprice ?? swapTwoDetails.price));
    } else {
      swapTwoAmt = swapOneUSd / (swaptwoprice ?? swapTwoDetails.price);
    }
    setSwapAmountTwo(swapTwoAmt);
    if (
        Number(amount) > Number(swaponebalance ?? swapOneDetails.balance) || 
        Number(swaponebalance ?? swapOneDetails.balance) === 0
    ) {
        setError(true);
    }else{
        setError(false);
    }
  }
  function handleSwap(){
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/swap.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_swap: true, swapAmountOne : swapAmountOne, swapAmountTwo: swapAmountTwo, swapCoinOne : swapOneDetails.name, swapCoinTwo: swapTwoDetails.name, swapSymbolOne : swapOneDetails.value, swapSymbolTwo: swapTwoDetails.value, swapPriceOne: swapOneDetails.price}) 
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
              window.location.href = "assets";
            }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }
  function Shuffle(){
    setSwapAmountOne(0);
    setSwapAmountTwo(0);
    setSwapOne(swapTwo);
    setSwapTwo(swapOne);
    setSwapOneDetails(swapTwoDetails);
    setSwapTwoDetails(swapOneDetails);
  }
  const [swaphistorys, setSwaphistorys] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchswap: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSwaphistorys(data.swaps);
      }
    })
    .catch(err => {
    })
  }, [user]);


  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Swap" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Swap" icon={<FontAwesomeIcon icon={faShuffle} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-4 offset-lg-4">
                <div className="mycard mt-5 position-relative">
                    {error && (
                        <p className="mb-0 text-danger" style={{fontSize:'12px'}}>Your current balance is {formatCurrency(swapOneDetails ?swapOneDetails.balance:0)} {swapOne}.</p>
                    )}
                    <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>You Pay</label>
                    <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                        <input 
                            type="number" 
                            placeholder={swapOneDetails ? (100 / swapOneDetails.price).toFixed(4) : '0.03'}
                            className="inputNone"
                            value={swapAmountOne}
                            onChange={(e) => {setSwapAmountOne(e.target.value); validateSwapOne({ value : e.target.value })}}
                        />
                        <Select 
                            options={assethistory} 
                            value={assethistory.find((opt) => opt.value === swapOne)}
                            onChange={(e) => {
                            setSwapOne(e.value);
                            const swapOneDetails = assethistory.find(opt => opt.value === e.value);
                            if (swapOneDetails) {
                                setSwapOneDetails(swapOneDetails);
                                validateSwapOne({ swaponeprice : swapOneDetails.price, swaponebalance : swapOneDetails.balance })
                            } else {
                                setSwapOneDetails([]);
                            }
                            }}
                            isSearchable
                            styles={darkThemeStyles1}
                            className="w-full"
                        />
                    </div>
                    <p className="mb-0 fw-semibold" style={{fontSize:'12px'}}>Balance: {Number(swapOneDetails ?swapOneDetails.balance:0).toFixed(5)}</p>
                    <div onClick={() => Shuffle()} className="bg-prime d-flex align-items-center justify-content-center rounded-3 position-absolute" style={{width:'50px',height:'50px',left:'50%',transform:'translateX(-50%)',cursor:'pointer',top:'32%'}}>
                        <FontAwesomeIcon icon={faShuffle} style={{fontSize: '20px'}} />
                    </div>
                    <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>You Get:</label>
                    <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                        <input
                            type="text"
                            className="inputNone"
                            value={swapAmountTwo}
                            readOnly
                        />
                        <Select 
                            options={assethistory} 
                            value={assethistory.find((opt) => opt.value === swapTwo)}
                            onChange={(e) => {
                            setSwapTwo(e.value);
                            const swapTwoDetails = assethistory.find(opt => opt.value === e.value);
                            if (swapTwoDetails) {
                                setSwapTwoDetails(swapTwoDetails);
                                validateSwapOne({ swaptwoprice : swapTwoDetails.price, twoSymbol : swapTwoDetails.value })
                            } else {
                                setSwapTwoDetails([]);
                            }
                            }}
                            isSearchable
                            styles={darkThemeStyles1}
                            className="w-full"
                        />
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0" style={{fontSize:'12px'}}>Balance: {Number(swapTwoDetails ?swapTwoDetails.balance:0).toFixed(5)}</p>
                        <p className="mb-0 text-danger" style={{fontSize:'12px'}}>Note: swap fee - {fee}%</p>
                    </div>
                    <div className={`myBtn w-100 text-center mt-4 ${disable1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable1 ? handleSwap : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Swap Coin'}</div>
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-5 position-relative">
                  <p className="mb-2 text-uppercase fw-bold">Swap History</p>
                  <div className="table-responsive scrollDown">
                    <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                        <thead>
                            <tr className="fs-7">
                                <th className="fw-normal text-light">ID</th>
                                <th className="fw-normal text-light">Reference</th>
                                <th className="fw-normal text-light">Type</th>
                                <th className="fw-normal text-light">Method</th>
                                <th className="fw-normal text-light">Amount</th>
                                <th className="fw-normal text-light">Date</th>
                                <th className="fw-normal text-light">Status</th>
                            </tr>
                        </thead>
                        <tbody style={{fontSize: '14px'}}>
                        {swaphistorys.length > 0 ? (
                            swaphistorys.map((asset, index) => {
                                const assetd = assethistory.find(opt => opt.value === asset.from_method);
                                const assetd1 = assethistory.find(opt => opt.value === asset.to_method);
                                return (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{asset.reference}</td>
                                    <td>Swap</td>
                                    <td>{assetd.name} {`->`} {assetd1.name}</td>
                                    <td>{Number(asset.amount).toFixed(5)} {assetd.value} {`->`} {Number(asset.toamount).toFixed(5)} {assetd1.value}</td>
                                    <td>{asset.date}</td>
                                    <td style={{color: asset.status === 'pending' ? 'orange' : asset.status === 'failed' ? 'red' : 'green'}}>{asset.status.charAt(0).toUpperCase() + asset.status.slice(1)}</td>
                                </tr>
                            )})
                        ) : (
                            <tr>
                                <td className="py-5 text-center" colSpan={7}>You have no swap history.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Swap